"use strict";
// @ts-ignore
try {
    self['workbox:strategies:6.5.4'] && _();
}
catch (e) { }
